import { useAuth } from '../../context/AuthContext';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../components/ui/card';
import { 
  Users, Calendar, Clock, FileText, FolderOpen, BookOpen, 
  Settings, ArrowRight
} from 'lucide-react';
import { Link } from 'react-router-dom';

const adminModules = [
  {
    title: 'User Management',
    description: 'Create, edit, and manage user accounts and roles',
    icon: Users,
    path: '/admin/users',
    color: 'bg-blue-100 text-blue-600'
  },
  {
    title: 'Schedule Templates',
    description: 'Configure shift templates and scheduling rules',
    icon: Calendar,
    path: '/admin/schedule-templates',
    color: 'bg-emerald-100 text-emerald-600'
  },
  {
    title: 'Pay Periods',
    description: 'Create and manage bi-weekly pay periods',
    icon: Clock,
    path: '/admin/pay-periods',
    color: 'bg-amber-100 text-amber-600'
  },
  {
    title: 'Document Management',
    description: 'Manage training, payroll, and onboarding documents',
    icon: FileText,
    path: '/admin/documents',
    color: 'bg-purple-100 text-purple-600'
  },
  {
    title: 'Audit Logs',
    description: 'View system activity and security logs',
    icon: Settings,
    path: '/admin/audit-logs',
    color: 'bg-slate-100 text-slate-600'
  }
];

export default function AdminPanel() {
  const { isAdmin } = useAuth();

  if (!isAdmin) {
    return (
      <div className="text-center py-20">
        <p className="text-slate-500">You don't have access to this page.</p>
      </div>
    );
  }

  return (
    <div className="space-y-6" data-testid="admin-panel">
      <div>
        <h1 className="text-3xl font-bold text-slate-900">Admin Panel</h1>
        <p className="text-slate-500 mt-1">Manage portal settings and configurations</p>
      </div>

      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {adminModules.map((module) => (
          <Link key={module.path} to={module.path}>
            <Card 
              className="hover:shadow-lg transition-all duration-200 cursor-pointer group"
              data-testid={`admin-module-${module.path.split('/').pop()}`}
            >
              <CardContent className="pt-6">
                <div className="flex items-start justify-between">
                  <div className={`h-12 w-12 rounded-xl ${module.color} flex items-center justify-center`}>
                    <module.icon className="h-6 w-6" />
                  </div>
                  <ArrowRight className="h-5 w-5 text-slate-300 group-hover:text-teal-500 transition-colors" />
                </div>
                <h3 className="font-semibold text-slate-900 mt-4">{module.title}</h3>
                <p className="text-sm text-slate-500 mt-1">{module.description}</p>
              </CardContent>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  );
}
